import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const companySecondary = (payload: { month: string; year: string }) => {
  const query = queryString.stringify({ month: payload.month, year: payload.year });
  return http.get(`${API_ENDPOINTS.dashboardCompanySecondary}?${query}`);
};

const zoneWiseSecondaryClosing = (payload: { month: string; year: string }) => {
  const query = queryString.stringify({ month: payload.month, year: payload.year });
  return http.get(`${API_ENDPOINTS.dashboardZoneWiseSecondaryClosing}?${query}`);
};

const divisionSecondary = (payload: { month: string; year: string }) => {
  const query = queryString.stringify({ month: payload.month, year: payload.year });
  return http.get(`${API_ENDPOINTS.dashboardDivisionSecondary}?${query}`);
};

const topSKUs = (payload: { month: string; year: string }) => {
  const query = queryString.stringify({ month: payload.month, year: payload.year });
  return http.get(`${API_ENDPOINTS.dashboardTopSKUs}?${query}`);
};

const avgInventoryDays = (payload: { month: string; year: string }) => {
  const query = queryString.stringify({ month: payload.month, year: payload.year });
  return http.get(`${API_ENDPOINTS.dashboardAvgInventoryDays}?${query}`);
};

const DashboardService = {
  companySecondary,
  zoneWiseSecondaryClosing,
  divisionSecondary,
  topSKUs,
  avgInventoryDays,
};

export default DashboardService;
